import { getCookieItem } from "@/lib/commonService";
import personalizeEvents, {
    EventType,
    personalizeBatchEventLogin,
    personalizeEvent,
} from "@/src/models/personalize";
import { ClickstreamAnalytics } from "@aws/clickstream-web";

// 错误处理包裹
function catchErrors(fn: Function) {
    return function (...args: any) {
        try {
            // @ts-ignore
            return fn.apply(this, args);
        } catch (error) {
            console.error(`Error occurred in function ${fn.name}:`, error);
        }
    };
}

class Acquisition {
    stadus: boolean = false;
    initParams = {
        appId: "firmoo_clickstream_app",
        endpoint: "https://click-stream.firmooinc.com/collect",
    };
    init(host: string) {
        this.onLoad();
    }
    // 初始化
    onLoad = catchErrors(() => {
        this.stadus = false;
        try {
            const result = ClickstreamAnalytics.init(this.initParams);
            this.stadus = result;
            // console.log("ClickstreamAnalytics加载成功");
            if (result) {
                const userid = getCookieItem("user_id") || null;
                ClickstreamAnalytics.setUserId(userid);
            }
        } catch (error) {
            this.stadus = false;
            console.log(error, "ClickstreamAnalytics加载失败");
        }
    });

    // 登录
    login = catchErrors((name: any, id: string) => {
        if (this.stadus) {
            // console.log(name, id);
            const userid = getCookieItem("user_id") || null;
            ClickstreamAnalytics.setUserId(userid);
            personalizeBatchEventLogin(Number(id));
        }
    });

    // 退出登录
    OutLogin = catchErrors((name: any, id: string | null) => {
        if (this.stadus) {
            // console.log(name, id);
            const userid = getCookieItem("user_id") || null;
            ClickstreamAnalytics.setUserId(userid);
        }
    });

    record = catchErrors((name: EventType, id: string) => {
        // 主动埋点
        personalizeEvents.putEvent(name, id);
        if (this.stadus) {
            personalizeEvent(name, id);
            ClickstreamAnalytics.record({
                name: name,
                attributes: { item_id: id },
            });
        }
    });

    // 收藏
    addWishlist = catchErrors((name: EventType, id: string) => {
        this.record(name, id);
    });

    // 商品点击
    clickProduct = catchErrors((name: EventType, id: string) => {
        this.record(name, id);
    });

    // 添加购物车
    addCart = catchErrors((name: EventType, id: string) => {
        this.record(name, id);
    });

    // tryOn
    tryOn = catchErrors((name: EventType, id: string) => {
        this.record(name, id);
    });

    // 创建订单
    createOrder = catchErrors(
        (name: EventType, id: string, orders_oid: string) => {
            if (Array.isArray(id)) {
                id.forEach((item) => {
                    personalizeEvents.putEvent(name, item);
                });
            } else {
                personalizeEvents.putEvent(name, id);
            }
            if (this.stadus) {
                personalizeEvent(name, id);
                const items = Array.isArray(id)
                    ? id.map((item) => {
                          return {
                              id: item,
                          };
                      })
                    : [{ id: id }];

                const attributes: any = {
                    items: items,
                    orders_oid: orders_oid,
                };

                ClickstreamAnalytics.record({
                    name: name,
                    attributes: attributes,
                });
            }
        },
    );

    // 支付成功
    paidOrder = catchErrors(
        (name: EventType, id: string, orders_oid: string) => {
            // 主动埋点
            personalizeEvents.putEvent(name, id);
            if (this.stadus) {
                personalizeEvent(name, id);
                ClickstreamAnalytics.record({
                    name: name,
                    attributes: { item_id: id, orders_oid: orders_oid },
                });
            }
        },
    );
}

let acquisition = new Acquisition();

export default acquisition;
